import { ErrorOutline, Info, Warning } from '@mui/icons-material';
import { Box, Dialog, DialogActions, Grid } from '@mui/material';
import InfoCard from 'lib/common/GeneralComponents/TenderModal/Components/InfoCard';
import SectionCard from 'lib/common/GeneralComponents/TenderModal/Components/SectionCard';
import AlertBanner from 'lib/designSystem/AlertBanner';
import CustomButton from 'lib/designSystem/Button';
import Title from 'lib/designSystem/Title';
import { Portfolio } from 'lib/types/models';
import React from 'react';

const InvalidateDialog = ({
  open,
  onClose,
  portfolio,
  handleInvalidatePortfolio,
  handleCancelInvalidate,
}: {
  open: boolean;
  onClose: () => void;
  portfolio: Portfolio;
  handleInvalidatePortfolio: () => Promise<void>;
  handleCancelInvalidate: () => void;
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        },
      }}
    >
      <Box sx={{ px: 2.5, pt: 2 }}>
        <Title
          title={'Invalidar Portafolio'}
          icon={<Warning color="warning" />}
          color="warning"
        />
      </Box>
      <Box sx={{ px: 2.5 }}>
        <SectionCard title="Información del Portafolio">
          <Grid container spacing={1.5}>
            <InfoCard
              icon={<Info />}
              label="Título"
              valueText={portfolio.title ?? 'Sin título'}
              color="primary.main"
            />
            <InfoCard
              icon={<ErrorOutline />}
              label="Estado Actual"
              valueText={portfolio.status}
              color="success.main"
            />
          </Grid>
        </SectionCard>
        <AlertBanner
          severity="warning"
          title="Advertencia"
          message="Esta acción invalidará el portafolio permanentemente. Si está asociado a un grupo de validación, causará que todo el grupo falle."
        />
      </Box>
      <DialogActions sx={{ p: 2.5, pt: 1 }}>
        <CustomButton color="secondary" onClick={handleCancelInvalidate}>
          Cancelar
        </CustomButton>
        <CustomButton color="error" onClick={handleInvalidatePortfolio}>
          Invalidar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default InvalidateDialog;
